import { IDocument } from '@lib-shared/types/Document';
import { ITag } from '@lib-shared/types/Tag';

export class ContractManagementHelper {
  static addUniqueTagsToDocuments(documents: IDocument[], tags: ITag[]): IDocument[] {
    return documents.map((document: IDocument) => ({
      ...document,
      tags: document.tags
        ? [
            ...document.tags,
            ...tags.filter((tagToAdd: ITag) => {
              const existingTagIds: string[] = document.tags.map(
                (existingTag: ITag) => existingTag.id
              );
              return !existingTagIds.includes(tagToAdd.id);
            }),
          ]
        : tags,
    }));
  }

  static updateDocumentsWithTaggedDocuments(
    stateDocuments: IDocument[],
    taggedDocuments: IDocument[]
  ): IDocument[] {
    return stateDocuments.map((stateDocument: IDocument) =>
      taggedDocuments.some((taggedDocument: IDocument) => taggedDocument.id === stateDocument.id)
        ? {
            ...stateDocument,
            tags: taggedDocuments.find(
              (taggedDocument: IDocument) => stateDocument.id === taggedDocument.id
            ).tags,
          }
        : stateDocument
    );
  }
}
